import { render } from "./feature-create.vue?vue&type=template&id=62bed0f9"
import script from "./feature-create.vue?vue&type=script&lang=js"
export * from "./feature-create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__